import classnames from 'classnames';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import ReactCommonmark from 'react-commonmark';
import { ExternalLink } from 'v2/models';
import { getAbsoluteLink } from 'v2/utils/dataProviderUtils';
import globeIcon from 'v2/icons/globe.svg';
import AvatarNameDetail from '../AvatarNameDetail';
import styles from './providerModals.module.scss';

interface ProviderModalProps {
  providerName: string;
  submittedBy: string;
  providerLogo: string;
  show: boolean;
  onHide: () => void;
  description: string;
  providerExternalLinks?: ExternalLink[];
}

const ProviderModal = ({
  show,
  onHide,
  submittedBy,
  providerLogo,
  providerName,
  description,
  providerExternalLinks,
}: ProviderModalProps) => {
  const providerWebsiteInfo = providerExternalLinks?.find((externalLink) =>
    externalLink.site_name === 'web' ? externalLink : null
  );

  return (
    <Modal size="lg" centered show={show} onHide={onHide} scrollable>
      <Modal.Header className="bg-light py-4">
        <Modal.Title>
          <AvatarNameDetail
            subtitle={submittedBy}
            image={providerLogo}
            title={providerName}
          />
        </Modal.Title>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
      </Modal.Header>
      <Modal.Body className={classnames(styles.modalBody, 'text-light4')}>
        {providerWebsiteInfo ? (
          <a
            href={getAbsoluteLink(providerWebsiteInfo.url)}
            className="py-4 d-block"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="providerWebsite"
          >
            <img src={globeIcon} className="mr-2" alt="websiteIcon"></img>
            Visit Website
          </a>
        ) : null}
        <ReactCommonmark source={description} softBreak="br" />
      </Modal.Body>
    </Modal>
  );
};

export default ProviderModal;
